import { render } from "./IdiomasMultiselect.vue?vue&type=template&id=2f38fe41&scoped=true"
import script from "./IdiomasMultiselect.vue?vue&type=script&lang=js"
export * from "./IdiomasMultiselect.vue?vue&type=script&lang=js"

import "./IdiomasMultiselect.vue?vue&type=style&index=0&id=2f38fe41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f38fe41"]])

export default __exports__